export default function getFallbackValueIfNull<T>(value: T | null, fallback: T): T {
    return value === null ? fallback : value;
}

export function getFallbackValueIfNullOrUndefined<T>(value: T | null | undefined, fallback: T): T {
    return value ?? fallback;
}
